module.exports = __webpack_public_path__ + "static/tipsAndTricksAlternativeFront-dc68637db0ceb1621aafc88a3f7c474f.png";